export default "__VITE_PUBLIC_ASSET__884e72cc__"